import { CAP_APPLICATIONS_ACTION_TYPES } from '../../constants/actionTypes/capApplicationsActionTypes';
interface IAction {
    type: string;
    payload?: any;
}
export const INITIAL_STATE = {
    currentYear: '',
    capApplicationsInfo: {
        currentApplications: [],
        pastApplications: [],
        coverageYear: null,
        insideOE: false,
        insideQEP: false,
        householdCaseId: null,
        queuedApplications: [],
        userPermissionList: [],
    },
    appControllerInfo: {},
    outBoundButtonStatus: false,
};
export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_APPLICATIONS: {
            return {
                ...state,
                capApplicationsInfo: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_CONTROLLER: {
            return {
                ...state,
                appControllerInfo: action.payload,
                currentYear: action.payload.currentCoverageYear,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR: {
            return {
                ...state,
                currentYear: action.payload,
            };
        }
        case CAP_APPLICATIONS_ACTION_TYPES.SET_OUTBOUND_BUTTON_STATUS: {
            return {
                ...state,
                outBoundButtonStatus: action.payload,
            };
        }
        default:
            return state;
    }
};
